if (typeof Object.id == "undefined") {
  var id = 0;
  Object.id = function (o) {
    if (typeof o.__uniqueid == "undefined") {
      Object.defineProperty(o, "__uniqueid", {
        value: ++id,
        enumerable: false,
        // This could go either way, depending on your
        // interpretation of what an "id" is
        writable: false,
      });
    }
    return o.__uniqueid;
  };
}

function HashTable() {
  var size = 0;
  var entry = new Object();

  this.add = function (key, value) {
    if (!this.containsKey(key)) {
      size++;
    }
    entry[key] = value;
  };

  this.getValue = function (key) {
    return this.containsKey(key) ? entry[key] : null;
  };

  this.remove = function (key) {
    if (this.containsKey(key) && delete entry[key]) {
      size--;
    }
  };

  this.containsKey = function (key) {
    return key in entry;
  };

  this.containsValue = function (value) {
    for (var prop in entry) {
      if (entry[prop] == value) {
        return true;
      }
    }
    return false;
  };

  this.getValues = function () {
    var values = new Array();
    for (var prop in entry) {
      values.push(entry[prop]);
    }
    return values;
  };

  this.getKeys = function () {
    var keys = new Array();
    for (var prop in entry) {
      keys.push(prop);
    }
    return keys;
  };

  this.getSize = function () {
    return size;
  };

  this.clear = function () {
    size = 0;
    entry = new Object();
  };
}

class AtlCtrlForET99 {
  AtlCtrlForET99 = function (clsid) {
    _classCallCheck(this, AtlCtrlForET99);
    this.clsid = clsid;
  };
  clsid = "{7356CC90-5909-4f44-A07E-329D0BD3FF81}";
  pid = "ffc5eb78";
  et99index = 1;
  ready_func_ = null;
  callbacks_ = new HashTable();
  module_ =
    String(navigator.platform).indexOf("Linux") > -1
      ? "libET99ForJS.so"
      : "JS_IActiveXCtrl";
  ws = null;
  messageQueue = []; // 消息队列，用于存储连接未建立时的消息
  isConnected = false; // 标记是否已连接
  
  initWS = () => {
    if ("WebSocket" in window && !this.ws) {
      this.ws = new WebSocket("ws://127.0.0.1:7321");
      this.ws.onerror = function (err) {
        console.log("ws 错误");
        this.isConnected = false;
      }.bind(this);
      this.ws.onopen = function() {
        this.isConnected = true;
        this.loadModule.bind(this)();
        // 发送队列中缓存的消息
        while (this.messageQueue.length > 0) {
          const msg = this.messageQueue.shift();
          this.ws.send(msg);
        }
      }.bind(this);
      this.ws.onclose = function () {
        console.log("ws 已经关闭");
        this.isConnected = false;
        this.ws = null;
      }.bind(this);
      this.callbacks_.add("LoadModule", this.loadModuleCallBack);
    } else {
      throw "WebSocket not supported";
    }
  };
  
  sendMessage = function(msg) {
    if (this.ws && this.isConnected && this.ws.readyState === WebSocket.OPEN) {
      this.ws.send(msg);
    } else {
      // 如果连接未建立，将消息加入队列
      this.messageQueue.push(msg);
    }
  };
  
  loadModule = function () {
    console.log("ws 已经开启");
    var msg = JSON.stringify({
      MsgId: "LoadModule",
      Module: this.module_,
    });
    this.ws.onmessage = this._callback.bind(this);
    this.sendMessage(msg);
  };
  
  closeModule = function (e) {};
  
  loadModuleCallBack = function (result, response) {
    if (!result) throw result.Response;
    if (this.ready_func_) ready_func_();
  }.bind(this);

  exec = function (func, param, callback) {
    var msg_id = Object.id(callback).toString();
    this.callbacks_.add(msg_id, callback);
    var param_ = {
      MsgId: msg_id,
      Method: func + "|" + this.clsid,
    };
    if (param) {
      param_["Param"] = JSON.stringify(param);
    }
    var msg = JSON.stringify(param_);
    this.sendMessage(msg);
  };
  ready = function (func) {
    this.ready_func_ = func;
  };
  _callback = function (response) {
    var r = JSON.parse(response.data);
    var msg_id = r.MsgId;
    if (r.Result) {
      console.info(r.Response);
    } else {
      console.error(r.response);
    }
    if (!this.callbacks_.containsKey(msg_id)) {
      return;
    }

    var callback = this.callbacks_.getValue(msg_id);
    callback(r.Result, r.Response);
    this.callbacks_.remove(msg_id);
  };
  ET99_FindToken = function (callback) {
    this.exec("ET99_FindToken", [this.pid], callback);
  };
  ET99_OpenToken = function (callback) {
    this.exec("ET99_OpenToken", [this.pid, parseInt(this.et99index)], callback);
  };
  ET99_GetSN = function (callback) {
    this.exec("ET99_GetSN", null, callback);
  };
  ET99_Verify = function (callback) {
    this.exec("ET99_Verify", [this.usertype, this.userpin], callback);
  };
  ET99_GenRandom = function (callback) {
    this.exec("ET99_GenRandom", null, callback);
  };
  ET99_SetKey = function (callback) {
    this.exec("ET99_SetKey", [parseInt(this.keyid), this.keybuff], callback);
  };
  ET99_HMAC_MD5 = function (callback) {
    this.exec(
      "ET99_HMAC_MD5",
      [parseInt(this.keyid), this.md5input?.length || 0, this.md5input],
      callback
    );
  };
  ET99_CloseToken = function (callback) {
    this.exec("ET99_CloseToken", null, callback);
  };
  ET99_Read = function (callback) {
    this.exec(
      "ET99_Read",
      [parseInt(this.roffset), parseInt(this.rlen)],
      callback
    );
  };
  ET99_Write = function (callback) {
    this.exec(
      "ET99_Write",
      [parseInt(this.woffset), parseInt(this.wlen), this.databuf],
      callback
    );
  };
  GetMacAddress = function (callback) {
    this.exec("GetMacAddress", null, callback);
  };
  ET99_ChangeUserPIN = function (callback) {
    this.exec("ET99_ChangeUserPIN", [this.oldpin, this.newpin], callback);
  };
  ET99_GenPID = function (callback) {
    this.exec("ET99_GenPID", [this.pidseed], callback);
  };
  ET99_GenPID = function (callback) {
    this.exec("ET99_GenPID", [this.pidseed], callback);
  };
  ET99_SetupToken = function (callback) {
    this.exec(
      "ET99_SetupToken",
      [
        parseInt(this.soPinRetries),
        parseInt(this.userPinRetries),
        parseInt(this.userReadOnly),
      ],
      callback
    );
  };
  ET99_GenSOPIN = function (callback) {
    this.exec("ET99_GenSOPIN", [this.pidseed], callback);
  };
  ET99_ResetPIN = function (callback) {
    this.exec("ET99_ResetPIN", [this.sopin], callback);
  };
  ET99_ResetSecurityState = function (callback) {
    this.exec("ET99_ResetSecurityState", null, callback);
  };
  ET99_TurnOnLED = function (callback) {
    this.exec("ET99_TurnOnLED", null, callback);
  };
  ET99_TurnOffLED = function (callback) {
    this.exec("ET99_TurnOffLED", null, callback);
  };
}
function isLinux() {
  const platform = navigator.platform.toLowerCase();
  const userAgent = navigator.userAgent.toLowerCase();
  return platform.indexOf("linux") > -1 || userAgent.indexOf("linux") > -1;
}

if (isLinux()) {
  var websock = true;
  var et99 = null;
  var pid = "ffc5eb78";
  var et99index = 1;
  var et99sn; //et99序列号
  var et99EncryptData;
  var tokencount;
  try {
    et99 = new AtlCtrlForET99("{7356CC90-5909-4f44-A07E-329D0BD3FF81}");
    et99.initWS();
  } catch (e) {
    et99 = document.getElementById("ET99");
    websock = false;
  }
  function ServerVerify(type, data, username, sn, key_pwd, ukm) {
    alert(sn);
  }
  //ET99
  function ET99_Check() {
    var key_pwd = "";
    var msg = "";
    ET99_FindToken(websock, pid);
    if (!websock) {
      tokencount = KeyCount;
      //open token
      ET99_OpenToken(websock, pid);
      //验证PIN
      ET99_Verify(websock, pid);
      //获取SN
      var sn = ET99_GetSN(websock, pid);
      //计算MD5值
      ET99_HMAC_MD_My(websock, pid, msg, key_pwd, msg);
      //关闭ET99
      ET99_CloseToken(websock, pid);
    } else {
      tokencount = KeyCount;
      //open token
      ET99_OpenToken(websock, pid);
      //验证PIN
      ET99_Verify(websock, pid);
      //获取SN
      ET99_GetSN(websock, pid);
      //计算MD5值
      ET99_HMAC_MD_My(websock, pid, msg, key_pwd, msg);
      //关闭ET99
      ET99_CloseToken(websock, pid);
    }
  }

  setTimeout(function () {
    ET99_Check();
  }, 2000);
  //查找et99
  var KeyCount = 0;
  var pid;
  var et99index;
  function ET99_FindToken(websock, _pid) {
    if (!websock) {
      et99 = document.getElementById("ET99");
      KeyCount = et99.ET99_FindToken(_pid);
      et99.ET99_OpenToken(_pid, 1);
    } else {
      pid = _pid;
      et99.ET99_FindToken(function (result, response) {
        if (!result) {
          KeyCount = -1;
        } else {
          KeyCount = response;
        }
      });
    }
    return KeyCount;
  }
  var rtn;
  //打开et99
  function ET99_OpenToken(websock, _pid) {
    if (!websock) {
      et99 = document.getElementById("ET99");
      rtn = et99.ET99_OpenToken(_pid, 1);
    } else {
      pid = _pid;
      et99index = 1;
      et99.ET99_OpenToken(function (result, response) {
        if (!result) {
        } else {
          rtn = response;
        }
      });
    }
  }

  //验证et99 PIN
  var userpin;
  var usertype;
  function ET99_Verify(websock, _pid) {
    if (!websock) {
      et99 = document.getElementById("ET99");
      rtn = et99.ET99_Verify(0, "ffffffffffffffff");
      if (0 == rtn) {
        //alert("验证PIN码成功");
      } else {
        //alert("验证PIN码失败");
      }
    } else {
      userpin = "ffffffffffffffff";
      usertype = 0;
      et99.ET99_Verify(function (result, response) {
        if (!result) {
          alert("ET99_Verify error. " + response);
        } else {
          rtn = response;
          if (0 == rtn) {
            //alert("验证PIN码成功");
          } else {
            //alert("验证PIN码失败");
          }
        }
      });
    }
  }

  //获取ET99 SN
  function ET99_GetSN(websock, _pid) {
    if (!websock) {
      et99 = document.getElementById("ET99");
      rtn = et99.ET99_GetSN();
      et99sn = rtn;
    } else {
      et99.ET99_GetSN(function (result, response) {
        if (!result) {
          alert("ET99_GetSN error. " + response);
        } else {
          rtn = response;
          et99sn = rtn;
        }
      });
    }
    return et99sn;
  }

  //通过et99的硬件计算MD5值
  var keyid;
  var md5input;
  function ET99_HMAC_MD5(websock, _pid, md5i) {
    if (!websock) {
      et99 = document.getElementById("ET99");
      rtn = et99.ET99_HMAC_MD5(1, 6, md5i);
      et99EncryptData = rtn;
    } else {
      keyid = 1;
      md5input = md5i;
      et99.ET99_HMAC_MD5(function (result, response) {
        if (!result) {
          et99EncryptData = "ET99_HMAC_MD5 error. " + response;
        } else {
          rtn = response;
          et99EncryptData = rtn;
        }
      });
    }
    return et99EncryptData;
  }

  function ET99_HMAC_MD_My(websock, _pid, md5i, key_pwd, msg) {
    if (!websock) {
      et99 = document.getElementById("ET99");
      rtn = et99.ET99_HMAC_MD5(1, 6, md5i);
      et99EncryptData = rtn;
    } else {
      keyid = 1;
      md5input = md5i;
      et99.ET99_HMAC_MD5(function (result, response) {
        if (!result) {
          et99EncryptData = "ET99_HMAC_MD5 error. " + response;
        } else {
          rtn = response;
          et99EncryptData = rtn;
          // et99sn 为key的序列号
          // todo
        }
      });
    }
    return et99EncryptData;
  }

  //关闭et99
  function ET99_CloseToken(websock, _pid) {
    if (!websock) {
      et99 = document.getElementById("ET99");
      et99.ET99_CloseToken();
    } else {
      et99.ET99_CloseToken(function (result, response) {
        if (!result) {
          alert("ET99_CloseToken error. " + response);
        } else {
        }
      });
    }
  }
}
export default AtlCtrlForET99;
